import * as React from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { ProjectConfig } from 'Global';
import Cookies from 'universal-cookie';
import { List } from 'devextreme-react';
import { Button, LinearProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import EmptyElement from './EmptyElement';

const cookies = new Cookies();

interface IAutocompleteList {
  name: string;
  id: number;
}



export default function AutocompletePlans(props: any) {

  const company_id = cookies.get('company_id');

  const {value, onChange, error} = props;
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const handleOpenList = () => {
  setOpen(true);
  };


  /*=================================================
    CLIENT AUTOCOMPLETE VARIABLES & FUNCTIONS
    =================================================*/
    interface IProjectList {
      inputValue?: string,
      plan_id?: number,
      plan_name: string,
    };
    const filter = createFilterOptions<IProjectList>();

    //setClientList
    const [list, setList] = useState<any []>([]);
    const [plan, setPlan] = useState<IProjectList | null>(null);
    
    useEffect(() => {
      
      axios.get(ProjectConfig.api_url + "/plans/list", 
      {
        params: {
          full_list: true,
        }
      })
        .then((response) => {
          console.log("Plans List",response.data);
          setList(response.data.list);
          setLoading(true)
           
        })
        .catch((err) => {
          console.log(err.data);
        })
    }, []);
    /* ================================================= 
    ===================================================*/


    let item_name = "";
    if (list && (value && value!=0)) 
    {
      console.log("value", value);
      
      item_name = list.find(obj => {
        return obj.plan_id === parseInt(value); 
      })
    } 
    
    
  return (
    <>

     {list.length > 0 ? 
     (
      <Autocomplete
        value={item_name}
        onChange={(event, newValue) => {
          if (typeof newValue === 'string') {
            setPlan({
              plan_name: newValue,
            });
          } else if (newValue && newValue.inputValue) {
            // Create a new value from the user input
            setPlan({
              plan_name: newValue.inputValue,
            });
          } else {
            setPlan(newValue);
            if (newValue?.plan_id!=null)
            {
              onChange({
                  target: {
                      value: newValue.plan_id.toString(),
                      name: "plan_id",
                  }
              })
            }
            else {
              onChange({
                target: {
                    value: "",
                    name: "plan_id",
                }
              })
            }
            
          }
          
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        fullWidth
        id="free-solo-with-text-demo"
        options={list}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.plan_name;
        }}
        renderOption={(props, option) => <li className="flex_select" {...props}>
          <div className="flex_option_1">{option.plan_name}</div>
        </li>}
        freeSolo
        renderInput={(params) => (
          <TextField 
          {...params} 
          label="Nombre del plan" 
          error={error}
          
          placeholder='Nombre del plan'
          />
        )}
        
      /> 
      )
      :
      (
        <>
        
        <LinearProgress />
        
        </>
      )}
    </>
  );
}
